import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import HomeMain from './Components/Home/HomeMain';
import FreelancersMain from './Components/Freelancers/FreelancersMain';
import { BrowserRouter as Router, Redirect, Route, Switch, useLocation } from 'react-router-dom';
import OrganizationMain from './Components/Organization/OrganizationMain';
import SmallbusinessMain from './Components/Business/SmallbusinessMain';
import Toolbar from './Components/Toolbar/Toolbar'
import SideDrawer from './Components/SideDrawer/SideDrawer'
import Backdrop from './Components/BackDrop/Backdrop';
import FAQMain from './Components/FAQ/FAQMain';
import TermsMain from './Components/Terms/TermsMain';
import CookiePolicyMain from './Components/CookiePolicy/CookiePolicyMain';
import OnlinePaymentsMain from './Components/OnlinePayment/OnlinePaymentsMain';
import PrivacyMain from './Components/PrivacyPolicy/PrivacyMain';
import Loader from './loader/Loader';
import PageNotFound from './Components/Common/PageNotFound';
import InvoiceGeneratorMain from './Components/InvoiceGenerator/InvoiceGeneratorMain';
import PriceMain from './Components/Pricing/PriceMain';
import ContractorsMain from './Components/NicheLanding/ContractorsMain';
import HandymenMain from './Components/NicheLanding/HandymenMain';
import CleanersMain from './Components/NicheLanding/CleanersMain';
import { LocaleProvider } from './localization/LocaleContext';
import { LOCALE_ROUTE_PREFIX, ROUTE_PATHS } from './localization/constants';
import {
    buildLocalizedPath,
    getPreferredLocale,
    getPreferredLocaleAsync,
    normalizeLocale,
    persistLocale,
    stripLocaleFromPathname
} from './localization/locale';

function localizedRoute(pathname) {
    if (pathname === ROUTE_PATHS.home) {
        return LOCALE_ROUTE_PREFIX;
    }

    return `${LOCALE_ROUTE_PREFIX}${pathname}`;
}

function LegacyRouteRedirect() {
    const location = useLocation();
    const [redirectPath, setRedirectPath] = useState(null);

    useEffect(() => {
        let cancelled = false;

        getPreferredLocaleAsync().then((locale) => {
            if (cancelled) return;
            const strippedPath = stripLocaleFromPathname(location.pathname);
            const path = buildLocalizedPath(locale, strippedPath);
            setRedirectPath(`${path}${location.search}${location.hash}`);
        });

        return () => { cancelled = true; };
    }, [location]);

    if (!redirectPath) return null;

    return <Redirect to={redirectPath} />;
}

function LocalizedApp({ locale }) {
    const [sideDrawerOpen, setSideDrawerOpen] = useState(false)

    useEffect(() => {
        const normalizedLocale = normalizeLocale(locale);
        persistLocale(normalizedLocale);
        document.documentElement.lang = normalizedLocale;
    }, [locale]);

    function drawerToggleClickHandler(){
        setSideDrawerOpen((currentValue) => !currentValue)
    }

    function backdropClickHandler(){
        setSideDrawerOpen(false)
    }

    let backdrop;

    if(sideDrawerOpen){
        backdrop = <Backdrop click={backdropClickHandler} />
    }

    return(
        <LocaleProvider locale={locale}>
            <Toolbar drawerClickHandler={drawerToggleClickHandler} />
            <SideDrawer show={sideDrawerOpen} drawerClickHandler={backdropClickHandler} />
            {backdrop}
            <Switch>
                <Route path={localizedRoute(ROUTE_PATHS.home)} exact component={HomeMain}/>
                <Route path={localizedRoute(ROUTE_PATHS.loader)} exact component={Loader} />
                <Route path={localizedRoute(ROUTE_PATHS.freelancers)} exact component={FreelancersMain}/>
                <Route path={localizedRoute(ROUTE_PATHS.organization)} exact component={OrganizationMain}/>
                <Route path={localizedRoute(ROUTE_PATHS.smallBusiness)} exact component={SmallbusinessMain} />
                <Route path={localizedRoute(ROUTE_PATHS.privacyPolicy)} exact component={PrivacyMain} />
                <Route path={localizedRoute(ROUTE_PATHS.faqs)} exact component={FAQMain}  />
                <Route path={localizedRoute(ROUTE_PATHS.termsOfService)} exact component={TermsMain} />
                <Route path={localizedRoute(ROUTE_PATHS.cookiePolicy)} exact component={CookiePolicyMain} />
                <Route path={localizedRoute(ROUTE_PATHS.onlinePayments)} exact component={OnlinePaymentsMain} />
                <Route path={localizedRoute(ROUTE_PATHS.invoiceGenerator)} exact component={InvoiceGeneratorMain} />
                <Route path={localizedRoute(ROUTE_PATHS.pricing)} exact component={PriceMain} />
                <Route path={localizedRoute(ROUTE_PATHS.contractors)} exact component={ContractorsMain} />
                <Route path={localizedRoute(ROUTE_PATHS.handymen)} exact component={HandymenMain} />
                <Route path={localizedRoute(ROUTE_PATHS.cleaners)} exact component={CleanersMain} />
                <Route component={PageNotFound} />
            </Switch>
        </LocaleProvider>
    )
}

const App = () => {
    return(      
        <Router>
            <Switch>
                <Route
                    path={LOCALE_ROUTE_PREFIX}
                    render={({ match }) => <LocalizedApp locale={match.params.locale} />}
                />
                <Route component={LegacyRouteRedirect} />
            </Switch>
        </Router> 
    )   
}

ReactDOM.render(<App />,document.querySelector('#root'));